import { render, staticRenderFns } from "./SdBaseLayers.vue?vue&type=template&id=d56d2e64&scoped=true"
import script from "./SdBaseLayers.vue?vue&type=script&lang=js"
export * from "./SdBaseLayers.vue?vue&type=script&lang=js"
import style0 from "./SdBaseLayers.vue?vue&type=style&index=0&id=d56d2e64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56d2e64",
  null
  
)

export default component.exports